import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import entriesReducer from "../features/entry/entrySlice";
import alertReducer from "../features/alert/alertSlice";
import activityReducer from "../features/activity/activitySlice";
import flagReducer from "../features/flag/flagSlice";
import userProfileReducer from "../features/userProfile/userProfileSlice";
import playerReducer from "../features/player/playerSlice";
import rankingReducer from "../features/ranking/rankingSlice";
import adminReducer from "../features/admin/adminSlice";
import bsaDataReducer from "../features/bsaData/bsaDataSlice";
import organisationReducer from "../features/organisation/organisationSlice";
import impersonationReducer from "../features/impersonation/impersonationSlice";

export default configureStore({
  reducer: {
    auth: authReducer,
    entry: entriesReducer,
    alert: alertReducer,
    activity: activityReducer,
    flag: flagReducer,
    userProfile: userProfileReducer,
    player: playerReducer,
    ranking: rankingReducer,
    admin: adminReducer,
    bsaData: bsaDataReducer,
    organisation: organisationReducer,
    impersonation: impersonationReducer,
  },
});
